import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_Student_Demographics } from "../shared/data.service";
import { StudentAddGuardianComponent } from "./student-add-guardian/student-add-guardian.component";
import { StudentEditGuardianComponent } from "./student-edit-guardian/student-edit-guardian.component";

@Component({
	selector: "caass-demographics-guardian-table",
	templateUrl: "./demographics-guardian-table.component.html",
	styleUrls: ["./demographics-guardian-table.component.css"],
})
export class DemographicsGuardianTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private DemographicsService: DataService_Student_Demographics,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadGuardian();
	}

	ngOnChanges() {
		this.loadGuardian();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedPerson: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGuardian: any;
	lstGuardian: any = [];

	//Filter lists
	lstRelationship: any = [];
	lstHomeLanguage: any = [];
	lstDefinedByDesc: any = [];
	lstCity: any = [];
	lstState: any = [];
	lstZip: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Name", header: "Name" },
		{ field: "Relationship", header: "Relationship" },
		{ field: "StreetAddress", header: "Address" },
		{ field: "City", header: "City" },
		{ field: "State", header: "State" },
		{ field: "Zip", header: "Zip" },
		{ field: "HomePhone", header: "Home Phone" },
		{ field: "WorkPhone", header: "Work Phone" },
		{ field: "CellPhone", header: "Cell Phone" },
		{ field: "EMail", header: "E-Mail" },
		{ field: "HomeLanguage", header: "Home Language" },
		{ field: "DefinedByDesc", header: "Defined By" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGuardian() {
		this.loading = true;

		if (this.SelectedPerson == undefined) {
			this.lstGuardian = [];
			this.loading = false;
			return;
		}

		var result = this.DemographicsService.LoadGuardian(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstGuardian = response;

				for (var i = 0; i < this.lstGuardian.length; i++) {
					var next = this.lstGuardian[i];

					if (next.DefinedByDesc != "System" && next.DefinedByDesc != "Import") {
						next.DefinedByDesc = "User";
					}
				}

				//Load Data Filter Lists
				this.lstRelationship = Array.from(new Set(this.lstGuardian.map((item: any) => item.Relationship))).sort();
				this.lstHomeLanguage = Array.from(new Set(this.lstGuardian.map((item: any) => item.HomeLanguage))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstGuardian.map((item: any) => item.DefinedByDesc))).sort();
				this.lstCity = Array.from(new Set(this.lstGuardian.map((item: any) => item.City))).sort();
				this.lstState = Array.from(new Set(this.lstGuardian.map((item: any) => item.State))).sort();
				this.lstZip = Array.from(new Set(this.lstGuardian.map((item: any) => item.Zip))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadGuardian();
	}

	//Custom Button Methods
	onAddGuardian() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentAddGuardianComponent, {
			header: "Add Guardian",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGuardian();
			}
		});
	}

	onEditGuardian() {
		this.errorMessage = "";

		//Double click can't edit if imported
		if (this.CanEdit() == false) {
			return;
		}

		var ref = this.dialogService.open(StudentEditGuardianComponent, {
			header: "Edit Guardian",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				SelectedGuardian: this.SelectedGuardian,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGuardian();
			}
		});
	}

	onDeleteGuardian() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGuardian == undefined) {
			this.errorMessage = "Select a guardian to delete";
			return;
		}

		if (this.SelectedGuardian.DefinedByDesc == "System" || this.SelectedGuardian.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot delete guardians that are system-defined or import-defined";
			return;
		}

		//Call SP
		var result = this.DemographicsService.DeleteGuardian(this.SelectedGuardian.Parent_PersonID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGuardian();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Guardian",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedGuardian = val.data;
	}
	onRowUnselect(val) {
		this.SelectedGuardian = null;
	}
	onRowDblClick(Guardian) {
		this.SelectedGuardian = Guardian;
		this.onEditGuardian();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	CanEdit() {
		if (this.SelectedGuardian == undefined) {
			return false;
		}

		if (this.SelectedGuardian.DefinedByDesc == "System" || this.SelectedGuardian.DefinedByDesc == "Import") {
			return false;
		}

		return true;
	}

	////////////////////////////////////////////
}
